import React from 'react';
import './FloatingButtons.css';
import { FaWhatsapp } from 'react-icons/fa';

function WhatsAppIcon() {
  return (
    <a
      href="https://wa.me/917905513982"
      className="floating-button whatsapp"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
}

export default WhatsAppIcon;
